import classNames from "classnames";
import DropdownTreeSelect from "react-dropdown-tree-select";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { IconChevronDown } from "@pentabd/icons";
import { InputSelect, Select, Tag, Text } from "@pentabd/ui";

import { useBaseData } from "@hooks/useBaseData";
import { useLanguage } from "@hooks/useLanguage";
import { useMasterData } from "@hooks/useMasterData";

import {
  getConvertedData,
  getConvertedPositionDataWithPostType,
  getConvertedUnitData,
} from "@helpers/baseDataConvert";
import { getPositionColor } from "@helpers/getPositionColor";
import { unitTreeDataConvert } from "@helpers/unitTreeDataConvert";

import { BASE_DATA } from "@constants/base-data";

import { PositionType } from "@type/HRM/position";

import { GENERAL_INFO } from "@validations/HRM/employee/generalInfoValidation";
import { useEffect, useState } from "react";
import { getEmployeesForProcurementApproval } from "@api/procurements/procurement";
import {
  getConvertedMetaData,
  getConvertedMetaDataForEmployee,
} from "@helpers/inventory/metaDataConvert";

const { DESIGNATIONS } = BASE_DATA;

export function SelectEmployeeForProcurementApprove({
  registeredName,
  portal,
  zIndex,
  forModal,
  cols,
}: {
  registeredName: string;
  portal?: boolean;
  zIndex?: number;
  forModal?: boolean;
  cols?: 2 | 3 | 4 | 6;
}) {
  const { t } = useTranslation();
  const { language } = useLanguage();
  const [employees, setEmployees] = useState<any>([]);

  const {
    register,
    control,
    watch,
    setValue,
    formState: { errors },
  } = useFormContext();

  // Those data are for some dropdowns or radio buttons options.
  const { data: positions } = useBaseData(DESIGNATIONS);

  let wing = watch(
    `${GENERAL_INFO.WING_DESK_IO_E0}-${registeredName}`,
  ) as string;
  let designation = watch(
    `${GENERAL_INFO.DESIGNATION}-${registeredName}`,
  ) as string;

  useEffect(() => {
    if (designation) {
      getEmployeesForProcurementApproval({
        positionId: Number(designation),
      })
        .then((res) => {
          setEmployees(res.data);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [wing, designation]);
  return (
    <div>
      <div className="row">
        <div
          className={classNames({
            "col-12 col-xl-4 col-2xl-2": cols === 2,
            "col-12 col-xl-4 col-2xl-3": cols === 3,
            "col-12 col-xl-4": cols === 4,
            "col-12 col-sm-6": cols === 6,
            "col-12": forModal,
            "col-xl-12 col-2xl-3": !cols && !forModal,
          })}
        >
          <Controller
            control={control}
            name={`${GENERAL_INFO.DESIGNATION}-${registeredName}`}
            render={({ field }) => {
              return (
                <Select
                  {...register(`${GENERAL_INFO.DESIGNATION}-${registeredName}`)}
                  options={getConvertedMetaData(positions, language)}
                  placeholder={t(
                    "EMPLOYEE.GENERAL_INFO.FORM.DESIGNATION.PLACEHOLDER",
                  )}
                  isSearchable
                  defaultValue={field.value as number}
                  onSelectItem={(designation) => {
                    setValue(
                      `${GENERAL_INFO.DESIGNATION}-${registeredName}`,
                      designation as number,
                    );
                  }}
                  suffix={<IconChevronDown size="16" />}
                />
              );
            }}
          />
        </div>

        {/* single employee dropdown */}
        {designation && (
          <div
            className={classNames({
              "col-12 col-xl-4 col-2xl-2": cols === 2,
              "col-12 col-xl-4 col-2xl-3": cols === 3,
              "col-12 col-xl-4": cols === 4,
              "col-12 col-sm-6": cols === 6,
              "col-12": forModal,
              "col-xl-12 col-2xl-5": !cols && !forModal,
            })}
          >
            <Controller
              control={control}
              name={`${registeredName}`}
              render={({ field }) => {
                return (
                  <InputSelect
                    {...register(`${registeredName}`, {
                      required: "Employee ID is required",
                    })}
                    options={getConvertedMetaDataForEmployee(
                      employees,
                      language,
                      true,
                    )}
                    defaultValue={field.value}
                    onSelectItem={(data: any) => {
                      setValue(`${registeredName}`, data);
                    }}
                    suffix={<IconChevronDown size="16" />}
                    error={errors as any}
                    placeholder={
                      language === "en"
                        ? "Select Employee"
                        : "কর্মচারী নির্বাচন করুন"
                    }
                  />
                );
              }}
            />
          </div>
        )}
      </div>
    </div>
  );
}
